import * as React from 'react';
import { Switch as SwitchUI } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import type { Switch as Interface } from '../../design/components';

export const Switch: React.FC<Interface> = ({
  name, description, state, hidden, inline, disabled, required, error
}) => {
  const [value, setValue] = state || [false, () => {}];

  const switchComponent = (
    <SwitchUI
      id={name}
      checked={!!value}
      onCheckedChange={setValue}
      disabled={disabled}
      required={required}
    />
  );

  // Inline mode: render just the switch
  if (inline) {
    return (
      <div className={cn('inline-flex', hidden && 'hidden')}>
        {switchComponent}
      </div>
    );
  }

  return (
    <div className={cn('flex items-center gap-2', hidden && 'hidden')} data-disabled={disabled}>
      {switchComponent}
      {name && (
        <Label
          htmlFor={name}
          className={cn(
            disabled && 'cursor-not-allowed opacity-70',
            error && 'text-destructive'
          )}
        >
          {name}
        </Label>
      )}
      {(error || description) && (
        <p className={cn('text-sm', error ? 'text-destructive' : 'text-muted-foreground')}>
          {error || description}
        </p>
      )}
    </div>
  );
};
